// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  loglevel: "debug",
  debugging: true,
  frontendAccountHost: "http://localhost:4200",
  accountRoot: 'http://localhost:7015',
  customMetricRoot: 'http://localhost:7031',
  dashboardRoot: 'http://localhost:7010/',
  openaiRoot: 'http://localhost:7039',
  toolRoot: 'http://localhost:7035',
  orderRoot: 'http://localhost:8511/',
  advertiserRoot: 'http://localhost:7028/',
  accountHost: 'http://localhost:4200',
  advertiserHost: 'http://localhost:4201',
  orderHost: 'http://localhost:4202',
  reportHost: 'http://localhost:4203',
  trackerHost: 'http://localhost:4204',
  reconcileHost: 'http://localhost:4206',
  fileRoot: 'http://localhost:7044/',
  helpRoot: 'http://localhost:8519',
  helpHost: 'http://localhost:4208',
  frontendReportHost: 'http://localhost:4203',
  frontendTrackerHost: 'http://localhost:4204',
  frontendReconcileHost: 'http://localhost:4206',
  frontendOrderHost: 'http://localhost:4202',
  reportRoot: 'http://localhost:7011',
  notificationRoot: 'http://localhost:7037',
  agentRoot: 'http://localhost:3014',
};
